import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { error } from "console";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { CommentsDialogComponent } from "src/app/components/comments-dialog/comments-dialog.component";
import { GsdRoles } from "src/app/enums/gsdRoles.enum";
import { ProjectInfo } from "src/app/Models/audit/ProjectInfo";
import { AuditOverviewService } from "src/app/services/Audit/audit-overview.service";
import { AuditSharedService } from "src/app/services/Audit/audit-shared.service";
import { ApiService } from "src/app/views/project-connects/services/api.service";
import { SelectCategoriesComponent } from "../../creation/auditor-details/select-categories/select-categories.component";

@Component({
  selector: "app-project-display",
  templateUrl: "./project-display.component.html",
  styleUrls: ["./project-display.component.css"],
})
export class ProjectDisplayComponent {
  displayedColumns = [
    "id",
    "name",
    "manager",
    "auditor",
    "client",
    "audit-start-date",
    "stage",
    // "view",
    "Actions/View",
  ];
  filterValue = "";
  dataSource: MatTableDataSource<ProjectInfo>;
  dataArray = new Array();
  totalAudits: number = 0;
  auditRequestSubmittedCount: number = 0;
  auditInitiatedCount: number = 0;
  auditCompletedCount: number = 0;
  loggedInEmployeeId: number;
  employeerole : any;
  isAdmin : boolean = false;
  isSuperAdmin : boolean = false;
  isSkillUser : boolean = false;
  isCompetencyLeader : boolean = false;
  isSubCompetencyLeader : boolean = false;
  showCreateAuditButton: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private router: Router,
    private auditSharedServiec: AuditSharedService,
    private auditOverviewService: AuditOverviewService,
    public datepipe: DatePipe,
    private apiService: ApiService,
    private dialog: MatDialog,
    private toastr: ToastrService,
  ) {
    // Create 100 users
    const users: ProjectInfo[] = [];
    this.dataSource = new MatTableDataSource<ProjectInfo>([]);
  }

  ngOnInit(): void {
    this.getProjects();
    this.UpdateShowCreateAuditButton();
    this.loggedInEmployeeId = parseInt(localStorage.getItem('Id')); 
    this.employeerole = localStorage.getItem('role');
    if(this.employeerole.includes(GsdRoles.CompetencyLeader)){
      this.isCompetencyLeader = true;
    }
    if(this.employeerole.includes(GsdRoles.SubCompetencyLeader) && !this.employeerole.includes(GsdRoles.CompetencyLeader)){
      this.isSubCompetencyLeader = true;
    }
    if(this.employeerole.includes(GsdRoles.SuperAdmin)){
      this.isSuperAdmin = true;
    }
    if(this.employeerole.includes(GsdRoles.Admin) && !this.employeerole.includes(GsdRoles.SuperAdmin)){
      this.isAdmin = true;
    }
    if(this.employeerole.includes(GsdRoles.SkillUser)){
      this.isSkillUser = true;
    }
  }

  getProjects() {
    this.apiService.getProjects().subscribe((data: ProjectInfo[]) => {
      let statusCounts = { 1: 0, 3: 0, 4: 0 };

      data.forEach((project) => {
        project.expectedAuditStartDate = this.datepipe.transform(
          project.expectedAuditStartDate,
          "dd/MM/yyyy"
        );
        if (statusCounts.hasOwnProperty(project.statusId)) {
          statusCounts[project.statusId]++;
        }
      });
      this.totalAudits = data.length;
      this.auditRequestSubmittedCount = statusCounts[4];
      this.auditInitiatedCount = statusCounts[1];
      this.auditCompletedCount = statusCounts[3];
      this.dataSource.data = data;
     // console.log(data);
    });
  }

  UpdateShowCreateAuditButton(){
    this.apiService.getIfUserCanCreateAudit().subscribe((data: boolean) => {
      this.showCreateAuditButton = data;
    },(error) => {
      //log out user
        this.toastr.error(error);
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter() {
    this.filterValue = this.filterValue.trim(); // Remove whitespace
    this.filterValue = this.filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = this.filterValue;
  }

  navigateToProjectOverview(auditId: number, auditorId: number) {
    this.auditSharedServiec.setAuditId(auditId);
    this.auditOverviewService.setAuditorEmployeeId(auditorId);
    this.router.navigate(["Home/Audit/Audit Overview"]);
  }

  openActionDialog(isApproved: boolean, auditId: number) {
    this.dialog.open(CommentsDialogComponent, { data: { isApproved: isApproved ? true : false } })
    .afterClosed()
    .subscribe((response) => {
      if (response) {
        // this.employee.comments = response;
        console.log(response);
        this.auditOverviewService.saveAuditStatus(auditId,isApproved ? 4 : 3, response.trim()).subscribe(
          (response) => {
            this.toastr.success("Successfully updated the audit status");
            this.getProjects(); // refresh the page
            console.log(response);
          },
          (error) => {
            this.toastr.error("Error in updating the status, Please try again.");
            console.log(error);
          }
        );
      }
    });
  }

  view(row: any): void {
    const dialog = this.dialog.open(SelectCategoriesComponent, {
      width: '1000px',
      height: '496px',
      minHeight: '496px',
      maxHeight:'496px',
      data: { audit: row }
    });
    dialog.afterClosed().subscribe(()=>{
      // this.GetNoCompetencyData();
    });
  }
}